import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import ValidationErrors from '../../../validations/ValidationErrors'
import { Grid, Tooltip } from '@material-ui/core'
import Divider from '@material-ui/core/Divider'
import UploadTemplate from '@src/routes/Configurators/components/UploadTemplate'
import messages from '../../../messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { Formik, Field, Form } from 'formik'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import { handleTabDelimitedText } from '@src/routes/Configurators/utils/TabDelimitedData'
import { PlateProduct } from '../enum'
import InfoIcon from '@material-ui/icons/Info'
import styles from '@src/routes/Configurators/utils/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => ({
  downloadWrapper: {
    textAlign: 'right',
    margin: theme.spacing(0),
  },
  contentRoot: {
    borderColor: 'white',
  },
  seperator: {
    textAlign: 'center',
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(-2),
  },
  fieldLabel: {
    marginTop: theme.spacing(5),
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(20),
    color: 'black',
    marginBottom: theme.spacing(5),
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(5),
  },
  text: {
    color: 'black',
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(2),
  },
  textarea: {
    width: '100%',
  },
  marginLeft: {
    marginLeft: theme.spacing(14),
    marginTop: theme.spacing(6),
  },
  copyPastArea: {
    marginLeft: theme.spacing(10),
    marginTop: theme.spacing(1),
  },
  verticleLine: {
    marginLeft: theme.spacing(15),
    marginTop: theme.spacing(4),
    height: 70,
    width: 1.6,
  },
  InfoPopup: {
    maxWidth: theme.spacing(64),
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    border: `1px solid ${theme.palette.common.white}`,
    boxShadow: '1px 1px 20px 1px lightgrey',
    padding: theme.spacing(5),
    fontSize: theme.typography.pxToRem(12),
    color: '#1b1b25',
    borderRadius: '2%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  arrow: {
    color: theme.palette.common.white,
  },
  tooltipMsg: {
    marginBottom: theme.spacing(4),
  },
  InfoIcon: {
    outlined: true,
    position: 'relative',
    fontSize: theme.typography.pxToRem(16),
    top: theme.spacing(0.5),
    marginLeft: theme.spacing(1.5),
  },
}))

function DnaPlateUploadMethod(props) {
  const classes = useStyles()
  const GlobalCSS = styles()
  const { upload } = props
  const { accept, handleUploadChange, productType } = props
  const intl = useIntl()
  return (
    <div className={classes.marginLeft}>
      <Grid container>
        <Grid item sm={2}>
          {
            <UploadTemplate
              accept={accept}
              handleUploadChange={handleUploadChange}
            />
          }
          {upload && (
            <div>
              <ValidationErrors errors={props.validationMessage} />
            </div>
          )}
        </Grid>
        <Grid item sm={1} className={classes.seperator}>
          <span className={classes.fieldLabel}>
            Or
            <Divider
              orientation="vertical"
              variant="inset"
              className={classes.verticleLine}
            />
          </span>
        </Grid>

        <Grid item sm={8} className={classes.copyPastArea}>
          <span className={classes.text}>
            <FormattedMessage {...messages.CONF_COPY_ENTRY_HEADING} />
          </span>

          <Tooltip
            title={
              <React.Fragment>
                {productType === PlateProduct.DnaPlate ? (
                  <>
                    <div className={classes.tooltipMsg}>
                      <FormattedMessage
                        {...messages.CONF_DNA_PLATE_COPYPASTE_HELP_TEXT1}
                      />
                    </div>
                    <FormattedMessage
                      {...messages.CONF_DNA_PLATE_COPYPASTE_HELP_TEXT2}
                    />
                  </>
                ) : (
                  <FormattedMessage
                    {...messages.CONF_DUPLEX_PLATE_COPYPASTE_HELP_TEXT}
                  />
                )}
              </React.Fragment>
            }
            classes={{ tooltip: classes.InfoPopup, arrow: classes.arrow }}
            arrow
            placement="bottom-end"
          >
            <InfoIcon
              aria-label="info"
              className={classes.InfoIcon}
              color="primary"
            ></InfoIcon>
          </Tooltip>

          <Formik
            initialValues={{ copypaste: '' }}
            validateOnChange
            onSubmit={(values, actions) => {
              setTimeout(() => {
                actions.setSubmitting(false)
              }, 1000)
            }}
          >
            {() => {
              return (
                <Form>
                  <Field
                    name="copypaste"
                    component={LiquidInputAdapter}
                    placeholder={intl.formatMessage(
                      messages.CONF_PEPSCREEN_PLACEHOLDER
                    )}
                    multiline
                    spellcheck={'false'}
                    cols={30}
                    rows={4}
                    filled
                    onKeyDown={(e) => {
                      if (e.key === 'Tab') {
                        const event = handleTabDelimitedText(e)
                        props.handlechange(event)
                      }
                    }}
                    value={props.text}
                    onChange={props.handlechange}
                    className={clsx(
                      classes.textarea,
                      GlobalCSS.placeHolderColorChanges
                    )}
                  />
                </Form>
              )
            }}
          </Formik>
          {!upload && (
            <div>
              <ValidationErrors errors={props.validationMessage} />
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  )
}

export default DnaPlateUploadMethod
